import axios from 'axios'

const article = {
    state: {
        id: undefined,
        bannerUrl: null,
        category: null,
        title: null,
        slug: null,
        content: null,
        status: null,
        schedulingTime: null,
        tags: null,
        description: null,
        keywords: null
    },
    mutations: {
        SET_ARTICLE_BANNER_URL(state, payload) {
            state.bannerUrl = payload
        },
        SET_ARTICLE_CATEGORY(state, payload) {
            state.category = payload
        },
        SET_ARTICLE_TITLE(state, payload) {
            state.title = payload
        },
        SET_ARTICLE_SLUG(state, payload) {
            if (payload && payload.length > 0) {
                state.slug = payload.replace(' ', '-');
            }
        },
        SET_ARTICLE_CONTENT(state, payload) {
            state.content = payload
        },
        SET_ARTICLE_STATUS(state, payload) {
            state.status = payload
        },
        SET_ARTICLE_SCHEDULING_TIME(state, payload) {
            state.schedulingTime = payload
        },
        SET_ARTICLE_TAGS(state, payload) {
            state.tags = payload
        },
        SET_ARTICLE_DESCRIPTION(state, payload) {
            state.description = payload
        },
        SET_ARTICLE_KEYWORDS(state, payload) {
            state.keywords = payload
        },
        EDIT_ARTICLE(state, payload) {

            state.id = payload.id
            state.bannerUrl = payload.banner_url
            state.category = payload.category
            state.title = payload.title
            state.slug = payload.slug
            state.content = payload.content
            state.status = payload.status
            state.schedulingTime = payload.scheduling_time
            state.tags = payload.tags
            state.description = payload.description
            state.keywords = payload.keywords

        }
    },
    actions: {
        createArticle: async ({
            commit,
            state
        }, status) => {

            commit('SET_ARTICLE_STATUS', status)

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const payload = await axios.post(`${process.env.VUE_APP_API}/article/create`, {
                    article: state
                }, config)

                // commit('SET_TAGS', payload.data.tags)

                return {
                    status: 200,
                    data: payload.data
                }
            } catch (error) {
                return {
                    status: 500,
                    error: error
                }
            }
        },
        setEditMode: ({
            commit
        }, payload) => {
            commit('EDIT_ARTICLE', payload)

        }
    },
    getters: {
        newArticle: state => state
    }
}

export default article